import { PreferenceSection, PreferenceSummary } from 'components/Settings';
import { useTranslation } from 'react-i18next';
import { isFeedbackSettingsDefault } from 'utils/helper';
import { usePreferenceSettings } from '../../Preferences';
import { getFeedbackStructureLabel, getFeedbackSummaryItems, getPreferenceInstructions } from '../preferenceSummary';

const Feedback = ({ sectionId }) => {
    const { defaults, saving, update, setFeedbackDialog, adminOverrideStates } = usePreferenceSettings();
    const { t } = useTranslation('assignment');
    const settings = defaults.feedbackSettings;
    const additionalInstructions = getPreferenceInstructions(defaults.feedbackCustomContext);
    const isDefault = isFeedbackSettingsDefault(settings) && !additionalInstructions;

    return (
        <PreferenceSection
            id={sectionId}
            title={t('common:ui.feedback', 'Feedback')}
            description={t(
                'settings.feedback.description',
                'Set your default AI feedback preferences, including feedback style and teaching examples. These settings apply across all assignments and can be overridden by assignment-specific feedback settings.'
            )}
            toggleLabel={t('settings.feedback.toggle-label', 'Feedback Settings to All Assignments')}
            toggleDescription={t(
                'settings.feedback.toggle-description',
                'Turn on feedback settings to ensure they apply to all assignments.'
            )}
            enabled={defaults.aiFeedbackEnabled}
            adminOverrideState={adminOverrideStates[sectionId]}
            disabled={saving}
            onToggle={(value) => update('aiFeedbackEnabled', value)}
        >
            <PreferenceSummary
                actionLabel={t('common:controls.change-settings', 'Change Settings')}
                defaultLabel={t('common:ui.default', 'Default')}
                isDefault={isDefault}
                items={getFeedbackSummaryItems(settings, additionalInstructions, t)}
                onAction={() => setFeedbackDialog('feedback')}
                structure={settings.structure}
                summaryTitle={getFeedbackStructureLabel(settings.structure, t)}
                title={t('settings.feedback.title', 'Assignment Feedback Settings')}
            />
        </PreferenceSection>
    );
};

export default Feedback;
